export interface Invopop {
	createdAt: number;
	data: {
		invopopStatus: InvopopStatus;
		registrationUrl?: string;
		taxAuthority: string;
	};
	externalId: string;
	externalService: string;
	id: number;
	status: GroupExternalStatus;
	updatedAt: number;
	userId: number;
}

export enum InvopopStatus {
	Unknown = 0,
	Initiated = 1,
	Waiting = 2,
	Uploaded = 3,
	Approved = 4,
	Failure = 5,
}

export enum GroupExternalStatus {
	Unknown = 'unknown',
	Approved = 'approved',
	Pending = 'pending',
	Invalid = 'invalid',
}
